import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpSwitchComponent } from '@ui/sp-switch';

import { SpShopCartIconSettingsComponent } from '@components/sp-shop-cart-icon-settings/src/sp-shop-cart-icon-settings.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { WebColorPickerComponent } from '@web/shared/components/web-color-picker/web-color-picker.component';
import { SpRadioGroupComponent } from '@ui/sp-radio-group';
import { SpFormControlsModule } from '@components/sp-form-controls';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        TooltipModule,
        SpSwitchComponent,
        BsDropdownModule,
        WebColorPickerComponent,
        SpRadioGroupComponent,
        SpFormControlsModule,
        SpShopCartIconSettingsComponent,
    ],
    exports: [SpShopCartIconSettingsComponent],
})
export class SpShopCartIconSettingsModule {}
